


<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-12 p-0 ">
    <!-- <app-header></app-header> -->
    <div class="overview-image-container">
      <div class="row">
        <div class="col-7 padding-left">
          <div class="row">
            <div class="col-6">
              <p>Start building</p>
            </div>
          </div>
          <div class="row">
            <div class="col-8">
              <p>your <span class="pl-2">organisation</span></p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="text">Manage your employess, invite guests to the park, events & much more..</p>
            </div>
          </div>
        </div>
        <div class="col-4">
          <img class="overview-image" src="../../assets/images/Bitmap.png" />
        </div>
        <div class="col-1"></div>
      </div>

    </div>
  </div>

  <div class="div-style">

    <label class="overview-label mt-3 mb-3">Organisation Overview</label>

    <div class="row row-padding pb-3" >
      <div class="p-5 emp-mask mb-3" routerLink="/company" (mouseover)="changeText=true" (mouseout)="changeText=false">
        <span *ngIf="!changeText"><img class="image-pos-emp"
            src="../../assets/images/overview-employees-checked-in.png" /></span>
        <span *ngIf="changeText"> <img class="image-pos-emp"
            src="../../assets//images/overview-employees-checked-in-hover.png" /></span>

        <div class="row">
          <div class="col-3 border-right pt-3">
            <div class="row">
              <div class="col-12 text text-center">
                Employees <br>enrolled
              </div>
            </div>
          </div>
          <div class="col-3  pl-4">
            <div class="row">
              <!-- <div class="col-12 text">
                Verified with invite access
              </div> -->
              <div class="col-12 text">
                Verified
              </div>
            </div>
            <div class="row">
              <!-- <div class="col-12 result pt-2">
                {{data?.verifiedWithVMSAccess}}
              </div> -->
              <div class="col-12 result pt-2">
                {{data?.verified}}
              </div>
            </div>
          </div>
          <!-- <div class="col-3">
            <div class="row">
              <div class="col-12 text">
                Verified without invite access
              </div>
            </div>
            <div class="row">
              <div class="col-12 result pt-2">
                {{data?.verifiedWithOutVMSAccess}}
              </div>
            </div>
          </div> -->
          <div class="col-3">
            <div class="row">
              <div class="col-12 text">
                Non-verified
              </div>
            </div>
            <div class="row">
              <div class="col-12 result pt-2">
                {{data?.nonVerified}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-padding pb-3" >

      <div class="p-4 mask mb-3" (mouseover)="changeText=true" (mouseout)="changeText=false"
        routerLink="/vms">
        <span *ngIf="!changeText"><img class="image-pos" src="../../assets/images/overview-meetings.png" /></span>
        <span *ngIf="changeText"> <img class="image-pos"
            src="../../assets/images/overview-meetings-booked-hover.png" /></span>

        <div class="row ">
          <div class="col-12 text">
            Events Participants approval pending
          </div>
        </div>
        <div class="row result">
          <div class="col-12 pt-3">
            {{data?.eventsParticipateApprovalPending}}
          </div>
        </div>
      </div>

      <div class="p-4 col-4-day-pass mask " (click)="routeToMeetingReport()" (mouseover)="changeDayPassText=true" (mouseout)="changeDayPassText=false">
        <span ><img class="image-pos-park" src="../../assets/images/parking.png" /></span>
        <div class="row">
          <div class="col-12 text">
            Visitor Data
          </div>
        </div>
        <div class="row">
          <div class="col-12 text2">
            (Today)
          </div>
        </div>
        <div class="row pt-2">
          <div class="col-6">
            <div class="row">
              <div class="col-12 text-center result">
                {{data?.overViewModelVisitorData?.expected}}
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center text2">
                Expected
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-12 text-center result">
                {{data?.overViewModelVisitorData?.checkedIn}}
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center text2">
                Checked-in
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>




</div>
<div>
